import { IProduct } from 'src/@interfaces'
import { Api } from './api'
import { getPromptDeliveryProductsParams } from './service.types'
import { payloadProducts, urlQuery } from '@grupoboticario/barril-del-chavo'

export async function getPromptDeliveryProducts(params: getPromptDeliveryProductsParams) {
  const { reseller, pagination } = params
  const resp = await Api.get(
    `/catalog/reseller/${reseller?.catalogSlug}/stock/?${urlQuery(pagination)}`,
  )
  return {
    ...resp.data,
    products: payloadProducts(resp.data.products) as unknown as IProduct[],
  }
}
